import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import GrIcon from "./GrIcon";
import icons from "../icons";
import { gr } from "../tokens";

// The big 16:9 image at the top of a detail page (a programme or a video without its video). The frame
// keeps its height while the image loads (no jump), and an image that cannot load (missing file, other
// bucket) shows a soft placeholder icon instead of a broken image with its alt text.
const frameSx = {
  display: "block",
  width: "100%",
  aspectRatio: "16 / 9",
};

export default function GrCoverImage({
  src,
  alt = "",
  placeholderIcon = icons.image,
  sx,
}) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);

  if (!src || failed) {
    return (
      <Box
        role="img"
        aria-label={alt || undefined}
        aria-hidden={alt ? undefined : true}
        sx={{
          ...frameSx,
          display: "grid",
          placeItems: "center",
          background: gr.color.tint,
          color: gr.color.brand,
          "& > svg": { width: gr.space[12], height: gr.space[12] },
          ...sx,
        }}
      >
        <GrIcon icon={placeholderIcon} />
      </Box>
    );
  }
  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      onError={() => setFailed(true)}
      sx={{ ...frameSx, objectFit: "cover", ...sx }}
    />
  );
}

GrCoverImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  placeholderIcon: PropTypes.object,
  sx: PropTypes.object,
};
